import { FC, useEffect, useState } from 'react';

import Particles, {
  initParticlesEngine,
  IParticlesProps,
} from '@tsparticles/react';
import { loadFull } from 'tsparticles';

export const LazyParticles: FC<Partial<IParticlesProps>> = (props) => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadFull(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  if (!init) return null;
  return <Particles {...props} />;
};
